import { useState, useEffect } from "react";
import { FileText, Download } from "lucide-react";
import api from "@/api";

const API_URL = (typeof window !== "undefined" && ["hana.ma", "www.hana.ma"].includes(window.location.hostname)) ? window.location.origin : process.env.REACT_APP_BACKEND_URL;

export default function ProQuestionnaires() {
  const [questionnaires, setQuestionnaires] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/studies/questionnaires")
      .then((r) => {
        const data = Array.isArray(r.data) ? r.data : r.data.questionnaires || [];
        setQuestionnaires(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = (code) => {
    const link = document.createElement("a");
    link.href = `${API_URL}/api/studies/questionnaires/${code}/pdf`;
    link.target = "_blank";
    link.click();
  };

  if (loading || !questionnaires.length) return null;

  return (
    <div data-testid="pro-questionnaires-section">
      <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-3">
        Questionnaires PRO
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {questionnaires.map((q) => (
          <button
            key={q.code}
            data-testid={`pro-download-${q.code}`}
            onClick={() => handleDownload(q.code)}
            className="flex items-center gap-3 p-3 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 hover:border-indigo-300 transition-all text-left group"
          >
            <div className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center flex-shrink-0 group-hover:bg-indigo-100 transition-colors">
              <FileText className="w-4 h-4 text-indigo-600" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-700 truncate">{q.name}</p>
              <p className="text-xs text-slate-400">{q.itemCount || q.items?.length || "?"} questions</p>
            </div>
            <Download className="w-4 h-4 text-slate-400 group-hover:text-indigo-600 transition-colors flex-shrink-0" />
          </button>
        ))}
      </div>
    </div>
  );
}
